import { render, staticRenderFns } from "./CreateTrainingProgram.vue?vue&type=template&id=42ab72c9"
import script from "./CreateTrainingProgram.vue?vue&type=script&lang=js"
export * from "./CreateTrainingProgram.vue?vue&type=script&lang=js"
import style0 from "./CreateTrainingProgram.vue?vue&type=style&index=0&id=42ab72c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports